import dayjs from 'dayjs';

/**
 * Función para formatear una fecha con hora
 * Formato por defecto: 00:00 horas del día lunes 01 de marzo
 */
export function formatDateTimeText(date: string | Date, format?: string) {
  if (!format) {
    format = 'HH:mm [horas del día] dddd DD [de] MMMM';
  }
  if (dayjs(date).isValid()) {
    return dayjs.utc(date).format(format);
  } else {
    return '';
  }
}
/**
 * Función que formatea una fecha en distintos formatos disponibles.
 * @param date Fecha ha formatear
 * @param format "DD-MM-YYYY" | "DD/MM/YYYY" | "YYYY-MM-DD" (Default: "DD-MM-YYYY")
 * @returns
 */
export function formatDate(
  date: string | Date,
  format: 'DD-MM-YYYY' | 'DD/MM/YYYY' | 'YYYY-MM-DD' = 'DD-MM-YYYY',
): string {
  if (dayjs(date).isValid()) {
    return dayjs.utc(date).format(format);
  } else {
    return '';
  }
}

/**
 * Normaliza un valor de fecha proveniente de un form (Date, ISO con Z,
 * o YYYY-MM-DD ya formateado) a un string YYYY-MM-DD listo para enviar
 * al backend. Evita que el navegador desplace el día según su zona
 * horaria al serializar un Date object (toISOString -> UTC) o al
 * reformatear un ISO con Z usando dayjs en hora local.
 *
 * Usar en: payloads de write (onSubmit) cuando el campo es date-only.
 */
export function toDateOnlyPayload(value: unknown): string {
  if (value instanceof Date) {
    return dayjs(value).format('YYYY-MM-DD');
  }
  if (typeof value === 'string') {
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return value;
    }
    return dayjs.utc(value).format('YYYY-MM-DD');
  }
  return '';
}

export function getDate(data: string) {
  let date = new Date(data);
  date.setHours(date.getHours() + date.getTimezoneOffset() / 60);
  return date;
}

export function calculateAge(birthdate: string | Date): number {
  const birth = dayjs(birthdate);
  const today = dayjs();

  if (!birth.isValid()) {
    throw new Error('Fecha de nacimiento no válida');
  }

  const preciseAge = today.diff(birth, 'year', true);
  return Math.floor(preciseAge);
}
